import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueTheMask from 'vue-the-mask';
import VueAlertify from 'vue-alertify';
import ToolkitVue, { CustomFilters, Loading } from 'sapitur-toolkit-vue';

import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'sapitur-toolkit-vue/dist/sapitur-toolkit-vue.css';
import '@/styles.scss';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueTheMask);
Vue.use(ToolkitVue);
Vue.use(CustomFilters);
Vue.use(Loading);

const opts = {
  notifier: {
    delay: 4,
    position: 'top-right',
  },
};

Vue.use(VueAlertify, opts);

const ENV = process.env.VUE_APP_ENV;

const isProduction = () => ENV === 'production' || ENV === 'homologation';

Vue.config.productionTip = isProduction();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
